import img1 from "../assets/headers/menstruatiedisk.nl-kiezen-herbruikbaar-wegwerp-disk.jpg";
import img2 from "../assets/faqImg/menstruatiedisk-zit-goed.jpg";
import img3 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-7222.jpg";

export const reusableDisc = [
    {
        alt: 'Herbruikbare disk naast wegwerp-exemplaren',
        caption: 'Herbruikbare disk naast wegwerp-exemplaren',
        image: img1,
    },
];

export const cervix = [
    {
        alt: '.',
        caption: 'Dwarsdoorsnede van een baarmoeder, waar je een disk draagt. De onderkant van je baarmoeder is je baarmoedermond.',
        image: img3,
    },
    {
        alt: '.',
        caption: 'Dwarsdoorsnede van een baarmoeder, waar je een disk draagt. De onderkant van je baarmoeder is je baarmoedermond.',
        image: img2,
    },

];